import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Row } from 'antd';
import { queryMaterialDocumentListBR } from '@api/administrative/material';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import TableOrg from './TableOrg';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentList: [],
      documentCondition: '',

      pagination: {},
      isLoading: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      // 分页设置
      backInfo.start && backInfo.limit && (this.current = backInfo.start);
      backInfo.start &&
        backInfo.limit &&
        (this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        });
      this.setState(
        {
          documentCondition: backInfo.documentCondition,
        },
        () => {
          this.getDocumentList();
        },
      );
    } else {
      this.getDocumentList();
    }
  }

  componentWillUnmount() {
    const { documentCondition } = this.state;
    const params = {
      path: this.props.location.pathname,
      ...this.pagination,
      documentCondition: documentCondition || '',
    };
    this.props.dispatch(setBackInfo(params));
  }

  // 资料文档列表
  getDocumentList = () => {
    const { documentCondition } = this.state;
    const params = {
      ...this.pagination,
      condition: documentCondition,
    };
    this.setState({
      isLoading: true,
    });
    queryMaterialDocumentListBR(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          documentList: res.data || [],
          pagination: {
            total: res.totalSize,
            pageSize: 15,
            current: this.current,
          },
          isLoading: false,
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 资料文档搜索
  handleSearch = () => {
    this.props.form.validateFields((err, values) => {
      const documentCondition = values.condition || '';
      this.pagination = {
        limit: 15,
        start: 1,
      };
      this.current = 1;
      this.setState(
        {
          documentCondition,
        },
        () => {
          this.getDocumentList();
        },
      );
    });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.getDocumentList();
  };

  render() {
    const { documentList, pagination, documentCondition, isLoading } = this.state;
    const { getFieldDecorator } = this.props.form;
    const parentProps = {
      documentList,
      pagination,
      isLoading,
      handleDel: this.handleDel,
      onChange: this.handleTableChange,
    };

    return (
      <Card>
        <Form>
          <Row>
            <Col span={4} style={{ paddingRight: '10px' }}>
              <FormItem>
                {getFieldDecorator('condition', {
                  initialValue: documentCondition,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem>
                <Button type="primary" onClick={this.handleSearch}>
                  搜索
                </Button>
              </FormItem>
            </Col>
          </Row>
        </Form>
        <TableOrg {...parentProps} />
      </Card>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/administrative/material/LookUp/Index.js